import React, { useState, useEffect } from 'react';

const SlideShow = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Choose banner based on device
  const bannerImage = isMobile ? "./bannerrr.png" : "./bannerrr1.png";

  return (
    <div className="relative w-full max-w-7xl mx-auto overflow-hidden bg-gray-50">
      {/* Single Image - No slideshow, no navigation buttons */}
      <img
        src={bannerImage}
        alt={isMobile ? "Mobile Banner" : "Desktop Banner"}
        className="w-full h-auto block"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "https://via.placeholder.com/1200x400/F3F4F6/9CA3AF?text=Banner";
        }}
      />
    </div>
  );
};

export default SlideShow;